import React, { Component } from 'react'
import scrollToComponent from 'react-scroll-to-component';
import About from './components/About'
import Contact from './components/Contact'
import Menu from './components/Menu'
import Wines from './components/Wines'

import './app.css'

class App extends Component {

  constructor(props) {

    super(props)

    this.About = React.createRef()
    this.Wines = React.createRef()
    this.Contact = React.createRef()
  }

  menuClicked = btn => {

    scrollToComponent(this[btn].current, {
      offset: -40, // menu height
      align: 'top',
      duration: 500
    })
  }

  render() {

    return (

      <div className='root'>
        <Menu menuClicked={this.menuClicked} />
        <About ref={this.About} />
        <Wines ref={this.Wines} />
        <Contact ref={this.Contact} />
      </div>
    )
  }
}

export default App